import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from 'Store/index';
export default useSelector as TypedUseSelectorHook<RootState>;
